import { ComponentProps } from 'react';

import { cx } from '@/ui/cva';

export type ContainerProps = ComponentProps<'div'> & {
    fill?: boolean;
};

export function Container({
    children,
    className,
    fill = false,
    ref,
    ...props
}: ContainerProps) {
    return (
        <div
            {...props}
            ref={ref}
            className={cx(
                'mx-auto w-full px-sm md:px-md lg:px-lg',
                !fill && 'max-w-container',
                className
            )}
        >
            {children}
        </div>
    );
}
